export const setUserSetting = (userSetting) => ({
  type: 'SET_USERSETTING',
  userSetting: userSetting,
});
